import * as React from 'react';
import {Card as MuiCard, CardActions, CardContent, CardHeader, Chip, Divider, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack} from '@mui/material';
import SubHeading from 'components/labels/SubHeading';
import Text from 'components/labels/Text';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Icon from 'components/icons/Icon';
import { AddinType, Plan, PlanType } from 'models/Plan';
import Button from 'components/buttons/Button';
import Box from 'components/layout/box/Box';
import { Price } from 'models/Price';
import DownloadsButton from 'views/downloads/DownloadsButton';
import MyListItem from 'components/list/MyListItem';
import Link from 'components/buttons/Link';

const CardPlan = (props: any) => {
    const {plan, checkoutHandler, ...rest} = props;
    const p: Plan = plan;
    const isFreePlan = p?.planType === PlanType.Free;
    const price: Price = p?.prices?.length > 0 ? p.prices[0] : null; 
    const priceLabel = isFreePlan ? "$0" : Price.valueText(price) ?? "";
    const includedIcon = <Icon small>check</Icon>;
    const excludedIcon = <Icon small color='red'>close</Icon>
    return (
        <Box height='100%' textAlign='center'>
            <MuiCard {...rest}>
                <Box margin={0}>
                    <Paper elevation={0}>

                        <Box p={2}>
                            <Chip variant="outlined" color="primary" label={p.name}/>
                            <Box m={2}>
                                <Box pl={5} pr={5} display="inline-block" position='relative'>
                                    <SubHeading variant="h3">{priceLabel}</SubHeading>
                                    <Box position="absolute" top={0} right={0}>
                                        <Text variant="caption">{Price.currencyText(price)}</Text>
                                    </Box>
                                </Box>

                                <Text variant="caption">per user per month</Text>
                            </Box>
                            {!isFreePlan && <Button onClick={()=>checkoutHandler(price.id)} fullWidth={false}>Buy now</Button>}
                            {isFreePlan && <DownloadsButton hideLogo hideDetailsLink />}
                            <Box mt={1}>
                            <Link fontSize="12px" to="/addins">Details</Link>
                            </Box>

                        </Box>
                    </Paper>
                </Box>

                <Divider variant="middle" />

                <CardContent>
                    <Text mb={2} align='left'>Zibbit is the easy way to assemble your material into a digital binder</Text>

                    <Stack spacing={2}>
                    <List disablePadding>
                            <MyListItem alignItems="center" icon={includedIcon}><Text>Exhibit Management</Text></MyListItem>
                            <MyListItem alignItems="center" icon={includedIcon}><Text>Drafting Assistance</Text></MyListItem>
                            <MyListItem alignItems="center" icon={includedIcon}><Text>Digital Binders (PDF)</Text></MyListItem>
                            <MyListItem alignItems="center" icon={p.addinType === AddinType.OfficeAddin ? includedIcon : excludedIcon}><Text>OneDrive Integration</Text></MyListItem>
                    </List>

                    <Divider variant="fullWidth" />


                    <Box>


                
                    <Text mb={0} align='left'>Platforms:</Text>

                    <List disablePadding>
                        
                        {p.wordPlatforms.map((f, i) => {
                            return(
                                    <MyListItem key={i} icon={f.include ? includedIcon : excludedIcon} alignItems='center'><Text>{f.label}</Text></MyListItem>
                            )
    
                        })}
                    </List>
                    </Box>
                    </Stack>


                </CardContent>
                <CardActions>
                </CardActions>
            </MuiCard>
        

        </Box>
    ) 
}

export default CardPlan;